import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback } from 'recoil'

import {
  Button,
  ContextMenu,
  makeButtonWithMenu,
  toastShow,
  CONTEXT_MENU_SIZE_SM,
  TOAST_VARIANT_SUCCESS,
  Flex
} from 'mailup-web-components'

import { searchState } from '../recoil/state/search'
import { pageErrorState, pageState } from '../recoil/state/page'
import { exportSMTPPlusMessages } from '../recoil/actions/actions'

const ExportButton = () => {
  const intl = useIntl()
  const ButtonComponent = props => (
    <Button
      kind='secondary'
      data-mu-test='btn-export-all'
      className='test-exportAll'
    >
      {intl.formatMessage({ id: 'Load.EmailMessageList.ActionExportAll' })}
    </Button>
  )

  const handleExport = useRecoilCallback(
    ({ snapshot, set }) => async exportType => {
      try {
        set(pageState, prev => ({
          ...prev,
          fetchingResults: true
        }))
        const searchForm = await snapshot.getPromise(searchState)
        await exportSMTPPlusMessages(searchForm, exportType)
        toastShow(
          intl.formatMessage({ id: 'Load.Common.ExportSuccess' }),
          TOAST_VARIANT_SUCCESS,
          'exportMessages',
          true
        )
      } catch (e) {
        set(pageErrorState, {
          error: intl.formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
          severity: 'danger'
        })
      } finally {
        set(pageState, prev => ({
          ...prev,
          fetchingResults: false
        }))
      }
    }
  )

  const MenuComponent = () => (
    <ContextMenu
      size={CONTEXT_MENU_SIZE_SM}
      items={[
        {
          label: intl.formatMessage({ id: 'Load.Common.ExportCSV' }),
          value: 'CSV',
          onClick: handleExport
        },
        {
          label: intl.formatMessage({ id: 'Load.Common.ExportXLSXX' }),
          value: 'XLS',
          onClick: handleExport
        },
        {
          label: intl.formatMessage({ id: 'Load.Common.ExportVisualReport' }),
          value: 'REPORTXLS',
          onClick: handleExport
        }
      ]}
    />
  )
  const ButtonWithMenu = makeButtonWithMenu(ButtonComponent, MenuComponent)

  return (
    <>
      <Flex width='100%' justifyContent='flex-end'>
        <ButtonWithMenu data-mu-test='c-smtpplus-list-export' />
      </Flex>
    </>
  )
}

export default ExportButton
